import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { queryClient } from './lib/queryClient';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          className: 'app-toast',
          style: {
            maxWidth: 'min(420px, calc(100vw - 32px))',
            minWidth: 0,
            overflow: 'hidden',
            background: 'var(--t-slate-100)',
            color: 'var(--t-slate-700)',
            border: '1px solid var(--t-slate-200)',
            borderRadius: '12px',
            fontSize: '14px',
            boxShadow: 'var(--t-shadow-lg)',
          },
          success: { iconTheme: { primary: 'var(--t-green-500)', secondary: 'var(--t-slate-100)' } },
          error: { iconTheme: { primary: 'var(--t-red-500)', secondary: 'var(--t-slate-100)' } },
          loading: { iconTheme: { primary: 'var(--t-brand-600)', secondary: 'var(--t-slate-100)' } },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
